import { allAssets, asset, type ImageAsset } from './imageAssets'

/**
 * The fifteen locked consultation specialties (CLAUDE.md), by the slug the
 * backend seeds in `20260615_0004__seed.sql`, mapped to the icon AMTC supplied
 * for it (M17-T18c, ADR-0041).
 *
 * The supplied set matches the locked list one-to-one. The mapping is spelled
 * out rather than derived because the filenames do not match the slugs —
 * `orthopae-1`, `internalmedicine` and `pediatrics` are as-exported and were
 * deliberately not renamed in T18a, so this is where the two vocabularies meet.
 *
 * Icons are **decorative** everywhere they render: the specialty name sits
 * beside them and is what assistive tech announces.
 */
export const SPECIALTY_ICON_NAMES: Readonly<Record<string, string>> = {
  orthopaedics: 'icons/orthopae-1',
  oncology: 'icons/oncology',
  cardiology: 'icons/cardiology',
  'fertility-ivf': 'icons/fertility-ivf',
  neurosurgery: 'icons/neurosurgery',
  dental: 'icons/dental',
  cosmetic: 'icons/cosmetics',
  wellness: 'icons/wellness',
  obgyn: 'icons/obgyn',
  paediatrics: 'icons/pediatrics',
  dialysis: 'icons/dialysis',
  'internal-medicine': 'icons/internalmedicine',
  'general-surgery': 'icons/general-surgery',
  dermatology: 'icons/dermatology',
  ent: 'icons/ent',
}

/** Every emitted icon, so a test can prove none is orphaned. */
export function emittedIconNames(): string[] {
  return Object.keys(allAssets()).filter((k) => k.startsWith('icons/'))
}

/**
 * The icon for a specialty slug, or null for anything not on the locked list —
 * the "All specialties" tile, and any slug the backend grows without an icon.
 * Null keeps the incumbent glyph rather than rendering a gap.
 */
export function specialtyIcon(slug: string | null | undefined): ImageAsset | null {
  if (!slug) return null
  const name = SPECIALTY_ICON_NAMES[slug]
  return name ? asset(name) : null
}
